// Icons
import { ReactComponent as HelpCenterIcon } from "@/assets/icons/header/ellipsis/HelpCenterIcon.svg";
import { ReactComponent as CommissionSupportIcon } from "@/assets/icons/header/ellipsis/CommissionSupportIcon.svg";
import { ReactComponent as PrivacyIcons } from "@/assets/icons/header/ellipsis/PrivacyIcons.svg";
import { ReactComponent as OrganizationChartIcon } from "@/assets/icons/header/ellipsis/OrganizationChartIcon.svg";
// Components
import RenderMenusOptions, { TRenderOptionConfiguration } from "./RenderMenusOptions";
// Constants
import actions from "@/Constants/actionsList";
// Hooks
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import { useWrapperLayer } from "@/Common/context/wrapperLayer/WrapperLayerContext";

export const ELLIPSE_MENU_REQUIRED_ACTIONS = [actions.VIEW_HELP_CENTER, actions.VIEW_ORGANIZATION_CHART, actions.VIEW_COMMISSION_SUPPORT];

export default function EllipseMenu() {
	const { useMultipleAuth } = useAuthorization();
	const { isDisabled } = useWrapperLayer();

	const options: TRenderOptionConfiguration[] = [
		{
			title: "Help Center",
			externalLink: true,
			link: "https://dealerautomationservices.atlassian.net/servicedesk/customer/portals",
			icon: <HelpCenterIcon />,
			requiredActions: [actions.VIEW_HELP_CENTER],
		},
		{
			title: "Support Requests",
			link: "/support-requests",
			icon: <CommissionSupportIcon />,
			requiredActions: [actions.VIEW_COMMISSION_SUPPORT],
		},
		{
			title: "Privacy",
			link: "/privacy",
			icon: <PrivacyIcons />,
			requiredActions: ["DISABLED"],
		},
		{
			title: "Organization Chart",
			link: "/organization-chart",
			icon: <OrganizationChartIcon />,
			requiredActions: [actions.VIEW_ORGANIZATION_CHART],
		},
	];

	const isAuthorized = useMultipleAuth(ELLIPSE_MENU_REQUIRED_ACTIONS, "atLeastOne");

	if (!isAuthorized || isDisabled) {
		return null;
	}

	return <RenderMenusOptions arrayOptions={options} />;
}
